export default __webpack_public_path__ + "static/media/1832.5821aef9.png";